<template>
  <div>
    <div class="flex justify-between items-center pointer my2" @click="open = !open">
      <div>
        <div class="caps" v-html="preventWidows(item.post_title)"></div>
        <h4 class="red fs-s m0" v-html="preventWidows(item.details.role)"></h4>
      </div>
      <div>
        <svg v-if="!open" width="24" height="8" viewBox="0 0 50 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.09961 0.689575L24.9688 16.6896L48.838 0.689575" stroke="black" stroke-width="2"/>
        </svg>
        <svg v-else width="24" height="8" viewBox="0 0 50 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M48.8379 16.6896L24.9687 0.689574L1.09948 16.6896" stroke="black" stroke-width="2"/>
        </svg>
      </div>
    </div>
    <div v-show="open" class="pb2 mb3 border-bottom">
      <span class="block mx-auto" v-html="preventWidows(item.description)"></span>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Person',

  data () {
    return {
      open: false
    }
  },

  props: ['item']
}
</script>

<style lang="css" scoped>
</style>